module.exports = __webpack_public_path__ + "static/media/ve.a0d8230b.svg";